























































import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckoutList from '@/components/account/CheckoutList.vue';
import { ActiveAccount } from '@/interfaces/ActiveAccount';
import { formatDateWithMonthName } from '@/helpers/dateFormatter';
import { Action } from 'vuex-class';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';

@Component({
    name: 'AccountCredit',
    components: {
        CheckoutList,
    },
})
export default class AccountCredit extends Vue {
    protected isLoaded: boolean = false;
    @Prop({required: true}) protected activeAccount!: ActiveAccount;
    @Action('user/getCheckoutList') private getCheckoutList!: (typeName: string) => Promise<unknown>;
    @Action('user/getProjectBillingsCredits') private getProjectBillingsCredits!: () => Promise<unknown>;

    protected get checkoutList() {
        if (this.isLoaded) {
            return this.$store.getters['user/checkoutList'];
        } else {
            return [];
        }
    }

    protected get projectBillingsCredits() {
        return this.$store.getters['user/projectBillingsCredits'];
    }

    protected creditExpires(endDate: string) {
        const oneDay = 24 * 60 * 60 * 1000;
        return Math.round(Math.abs((new Date().getTime() - new Date(endDate).getTime()) / (oneDay)));
    }

    protected formattedDate(dateTimestamp: string) {
        return formatDateWithMonthName(dateTimestamp);
    }

    protected percentageRemaining(records: number, recordsUsed: number) {
        const result = ((records - recordsUsed) / records) * 100;
        if (result !== Math.round(result)) {
            return result.toFixed(1) + '%';
        } else {
            return result + '%';
        }
    }

    protected async mounted() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.getCheckoutList('prepaid').then(() => {
            this.isLoaded = true;
        });
        await this.getProjectBillingsCredits().then(() => {
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        });
    }

}
